//constante de paginação 
export const PAGE_SIZE_OPTIONS: number[] = [10, 20, 50, 100];
export const PAGE_SIZE_DEFAULT = 20;